// src/views/Pages/Invoices/useInvoicePDF.ts
import { getJwt } from "src/auth";

const BASE_URL = process.env.NODE_ENV === "production" ? "https://www.docuclipper.com" : "http://localhost:8080";

const useInvoicePDF = ({
  transactionLine,
  selectedDocumentId,
}) => {
  const pageNumber = transactionLine ? transactionLine.pageNumber : 0;
  const jwt = getJwt();

  const pdfURL = selectedDocumentId && transactionLine
    ? `${BASE_URL}/api/v1/protected/document/${selectedDocumentId}/file.pdf?token=${jwt}#page=${pageNumber + 1}&toolbar=0`
    : "";

  console.log("[useInvoicePDF] Debug:", {
    selectedDocumentId,
    transactionLineId: transactionLine?.id,
    pageNumber,
    hasJwt: !!jwt,
    jwtLength: jwt?.length,
    pdfURL: pdfURL ? `${pdfURL.substring(0, 100)}...` : "(empty)",
    baseUrl: BASE_URL,
  });

  return {
    pdfURL,
    pageNumber,
  };
};

export default useInvoicePDF;